import { faBolt, faBoxOpen, faFileCircleCheck, faFileSignature, faLightbulb } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch, useSelector } from "react-redux";
import { LuUtilityPole } from "react-icons/lu";
import { PiBlueprint } from "react-icons/pi";
import { changeTab, newTab, setTabFromNewIndex } from "../../state/slices/tabsSlice";
import styles from "./Dashboard.module.css"
import { useEffect } from "react";
import { useState } from "react";
import servLogin from "../../services/login/servLogin";
import { Box, CircularProgress } from "@mui/material";
import { style as modelStyle } from "../../components/Loading/Loading";

const Dashboard = () => {
    const dispatch = useDispatch();
    const tabs = useSelector(state => state.tabs);
    const user = useSelector(state => state.user);
    const [permissoes, setPermissoes] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    
    const onClickAbrirGeracaoDistribuida = () => {
        dispatch(newTab({ Nome: "Geração distribuída", Aba: 7 }));

        dispatch(setTabFromNewIndex(7));
    }
    
    const onClickAbrirCompInfraestrutura = () => {
        dispatch(newTab({ Nome: "Compartilhamento de infraestrutura", Aba: 8 }));

        dispatch(setTabFromNewIndex(8));
    }

    const onClickAbrirProjetosParticulares = () => {
        dispatch(newTab({ Nome: "Projetos particulares", Aba: 16 }));

        dispatch(setTabFromNewIndex(16));
    }

    useEffect(() => {
        const recuperarPermissaoModulo = async () => {
            try {
                const response = await servLogin.permissoesModulos();
                setPermissoes(response.Content);
                setIsLoading(false);
            } catch (err) {
                setIsLoading(false);
                console.log("erro" + err);
            }
        }

        recuperarPermissaoModulo();
    }, []);

    return (
        <div className={styles.dashboard_main}>
            <h3>Bem vindo, {user.name}.</h3>
            <section className={styles.dashboardSection}>
                {isLoading && (
                    <Box style={modelStyle} >
                        <CircularProgress color="inherit" />
                    </Box>
                )}
                { permissoes?.GeracaoDistribuida && <button className={styles.dashboardButton} onClick={onClickAbrirGeracaoDistribuida}>
                    <FontAwesomeIcon icon={faBolt} size="2x"/>
                    Geração distribuída
                </button>}
                
                { permissoes?.CompartilhamentoInfraestrutura && <button className={styles.dashboardButton} onClick={onClickAbrirCompInfraestrutura}>
                    <LuUtilityPole size="38px"/>
                    Comp. Infraestrutura
                </button>}

                { permissoes?.ProjetosParticulares && <button className={styles.dashboardButton} onClick={onClickAbrirProjetosParticulares}>
                    <PiBlueprint size="38px"/>
                    Projetos particulares
                </button>}
            </section>
            <p className={styles.merchanUseall}>Desenvolvido por <a className={styles.linkUseall} href="http://www.useall.com.br" target={"_blank"}>Useall Software</a></p>
        </div>
    )
};

export { Dashboard };